import { api } from 'src/boot/axios';
import { defineStore, storeToRefs } from 'pinia';
import { getResponseData } from 'utils';
import { TNormalizedMeeting } from 'types';
import { trace } from 'src/boot/trace';
import { useProfileStore } from 'stores/profile-store';
import { UNIT_MEMBERSHIP_TYPE } from 'boot/constants';

type State = {
  meetings: TNormalizedMeeting[];
  loading: boolean;
};

export const useMeetingsStore = defineStore('meetings', {
  state: (): State => ({
    meetings: [],
    loading: false, // TODO: implement
  }),
  actions: {
    cacheMeetingData(data: TNormalizedMeeting[]) {
      if (data) {
        localStorage.setItem('meetings', JSON.stringify(data));
        trace('Caching meeting data:', 'info', `${data?.length ?? 0} items`);
      }
    },
    fetchMeetingData(filter: string | null = null) {
      return api.get(`/api/v1/meeting-dates?pg=1&ps=30&${filter}`);
    },
    async getMemberMeetings() {
      const { user } = storeToRefs(useProfileStore());

      const unitIds = Array.isArray(user?.value?.units)
        ? user?.value?.units
            .map((unit) => {
              if (
                [
                  UNIT_MEMBERSHIP_TYPE.SUBSCRIBING,
                  UNIT_MEMBERSHIP_TYPE.HONORARY,
                ].includes(unit?.membership_type_id)
              ) {
                return unit.id;
              }
            })
            .filter((unitId) => unitId !== undefined && !isNaN(unitId))
            .join(',')
        : null;

      try {
        const response = await this.fetchMeetingData(
          `filter[unit_id]=${unitIds}`
        );
        this.meetings = getResponseData(response);
      } catch {
        // Handle permission errors (403) and other failures gracefully
        this.meetings = [];
      }
    },
    async getUnitMeetings(unit_id: number) {
      const response = await this.fetchMeetingData(
        `filter[unit_id]=${unit_id}`
      );
      return getResponseData(response);
    },
    clear() {
      this.meetings = [];
    },
  },
});
